const Dimens = {
	/** 0px */
	spacingNone: '0px',
	/** 1px */
	spacing3xs: '1px',
	/** 2px */
	spacing2xs: '2px',
	/** 4px */
	spacingXs: '4px',
	/** 6px */
	spacingSm: '6px',
	/** 8px */
	spacingMd: '8px',
	/** 12px */
	spacingLg: '12px',
	/** 16px */
	spacingXl: '16px',
	/** 20px */
	spacing2xl: '20px',
	/** 24px */
	spacing3xl: '24px',
	/** 32px */
	spacing4xl: '32px',
	/** 40px */
	spacing5xl: '40px',
	/** 48px */
	spacing6xl: '48px',
	/** 64px */
	spacing7xl: '64px',
	/** 80px */
	spacing8xl: '80px',
	/** 96px */
	spacing9xl: '96px',
	/** 128px */
	spacing10xl: '128px',
	/** 160px */
	spacing11xl: '160px',
	/** 180px */
	spacing12xl: '180px',

	/** 0px */
	radiusNone: '0px',
	/** 2px */
	radius2xs: '2px',
	/** 4px */
	radiusXs: '4px',
	/** 6px */
	radiusSm: '6px',
	/** 8px */
	radiusMd: '8px',
	/** 10px */
	radiusLg: '10px',
	/** 12px */
	radiusXl: '12px',
	/** 16px */
	radius2xl: '16px',
	/** 20px */
	radius3xl: '20px',
	/** 24px */
	radius4xl: '24px',
	/** 9999px */
	radiusFull: '9999px',

	/**
	 * Return a fixed size in pixels.
	 * @param size - The size in pixels.
	 * @returns The size in pixels.
	 */
	fixed(size: number): `${number}px` {
		return `${size}px`;
	},
};

export default Dimens;
